import type { KeyboardEvent as ReactKeyboardEvent } from "react";

/**
 * IME-safe Enter key check.
 * Returns true only when Enter is pressed AND no IME composition is active.
 * Prevents double-trigger on non-English keyboards (CJK, Vietnamese, etc.)
 * where pressing Enter to confirm IME input also fires a keydown event.
 *
 * @example
 * const handleKeyDown = (e: React.KeyboardEvent) => {
 *   if (isEnterKey(e)) handleSave();
 * };
 *
 * // With modifier check
 * const handleKeyDown = (e: React.KeyboardEvent) => {
 *   if (isEnterKey(e) && !e.shiftKey) handleSend();
 * };
 */
export function isEnterKey(e: ReactKeyboardEvent): boolean {
  return e.key === "Enter" && !e.nativeEvent.isComposing;
}

/**
 * Native DOM variant of isEnterKey for document.addEventListener handlers.
 * React's isEnterKey uses e.nativeEvent.isComposing, but native KeyboardEvent
 * has isComposing directly on the event object.
 */
export function isEnterKeyNative(e: KeyboardEvent): boolean {
  return e.key === "Enter" && !e.isComposing;
}
